import createReactComponent from '../createReactComponent';
export default createReactComponent('axis-x', 'IconAxisX', [
  ['path', { d: 'M4 13v.01', key: 'svg-0' }],
  ['path', { d: 'M4 9v.01', key: 'svg-1' }],
  ['path', { d: 'M4 5v.01', key: 'svg-2' }],
  ['path', { d: 'M17 20l3 -3l-3 -3', key: 'svg-3' }],
  ['path', { d: 'M4 17h16', key: 'svg-4' }],
]);
